module.exports = __webpack_public_path__ + "img/20191029164013360截图20191029155413819.29c55de3.jpg";